import './inputField.svelte.css';
/* src\components\pixel\inputField.svelte generated by Svelte v3.55.1 */
import {
	SvelteComponent,
	append,
	attr,
	binding_callbacks,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	set_data,
	set_input_value,
	set_style,
	space,
	text,
	toggle_class
} from "../../../_snowpack/pkg/svelte/internal.js";

import { onMount, createEventDispatcher } from '../../../_snowpack/pkg/svelte.js';

function create_if_block_6(ctx) {
	let span;
	let t_value = /*icon*/ ctx[1].name + "";
	let t;
	let span_style_value;

	return {
		c() {
			span = element("span");
			t = text(t_value);
			attr(span, "class", "material-symbols-outlined svelte-1luxt1k");
			attr(span, "style", span_style_value = "margin-left:5px;" + (/*icon*/ ctx[1].style ? /*icon*/ ctx[1].style : ''));
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*icon*/ 2 && t_value !== (t_value = /*icon*/ ctx[1].name + "")) set_data(t, t_value);

			if (dirty[0] & /*icon*/ 2 && span_style_value !== (span_style_value = "margin-left:5px;" + (/*icon*/ ctx[1].style ? /*icon*/ ctx[1].style : ''))) {
				attr(span, "style", span_style_value);
			}
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (115:31) 
function create_if_block_5(ctx) {
	let textarea;
	let mounted;
	let dispose;

	return {
		c() {
			textarea = element("textarea");
			attr(textarea, "rows", /*rows*/ ctx[12]);
			textarea.required = /*required*/ ctx[6];
			attr(textarea, "name", /*name*/ ctx[7]);
			attr(textarea, "placeholder", /*placeholder*/ ctx[4]);
			attr(textarea, "style", "");
			attr(textarea, "class", "svelte-1luxt1k");
			toggle_class(textarea, "dark-mode", /*darkMode*/ ctx[3]);
		},
		m(target, anchor) {
			insert(target, textarea, anchor);
			set_input_value(textarea, /*value*/ ctx[15]);
			/*textarea_binding*/ ctx[39](textarea);

			if (!mounted) {
				dispose = [
					listen(textarea, "input", /*textarea_input_handler*/ ctx[38]),
					listen(textarea, "focus", /*focus_handler_4*/ ctx[40]),
					listen(textarea, "focusout", /*focusout_handler_4*/ ctx[41])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty[0] & /*rows*/ 4096) {
				attr(textarea, "rows", /*rows*/ ctx[12]);
			}

			if (dirty[0] & /*required*/ 64) {
				textarea.required = /*required*/ ctx[6];
			}

			if (dirty[0] & /*name*/ 128) {
				attr(textarea, "name", /*name*/ ctx[7]);
			}

			if (dirty[0] & /*placeholder*/ 16) {
				attr(textarea, "placeholder", /*placeholder*/ ctx[4]);
			}

			if (dirty[0] & /*value*/ 32768) {
				set_input_value(textarea, /*value*/ ctx[15]);
			}

			if (dirty[0] & /*darkMode*/ 8) {
				toggle_class(textarea, "dark-mode", /*darkMode*/ ctx[3]);
			}
		},
		d(detaching) {
			if (detaching) detach(textarea);
			/*textarea_binding*/ ctx[39](null);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (109:31) 
function create_if_block_4(ctx) {
	let input;
	let mounted;
	let dispose;

	return {
		c() {
			input = element("input");
			input.required = /*required*/ ctx[6];
			attr(input, "name", /*name*/ ctx[7]);
			attr(input, "type", "password");
			attr(input, "placeholder", /*placeholder*/ ctx[4]);
			attr(input, "style", "");
			attr(input, "class", "svelte-1luxt1k");
			toggle_class(input, "dark-mode", /*darkMode*/ ctx[3]);
		},
		m(target, anchor) {
			insert(target, input, anchor);
			set_input_value(input, /*value*/ ctx[15]);
			/*input_binding_3*/ ctx[35](input);

			if (!mounted) {
				dispose = [
					listen(input, "input", /*input_input_handler_3*/ ctx[34]),
					listen(input, "focus", /*focus_handler_3*/ ctx[36]),
					listen(input, "focusout", /*focusout_handler_3*/ ctx[37])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty[0] & /*required*/ 64) {
				input.required = /*required*/ ctx[6];
			}

			if (dirty[0] & /*name*/ 128) {
				attr(input, "name", /*name*/ ctx[7]);
			}

			if (dirty[0] & /*placeholder*/ 16) {
				attr(input, "placeholder", /*placeholder*/ ctx[4]);
			}

			if (dirty[0] & /*value*/ 32768 && input.value !== /*value*/ ctx[15]) {
				set_input_value(input, /*value*/ ctx[15]);
			}

			if (dirty[0] & /*darkMode*/ 8) {
				toggle_class(input, "dark-mode", /*darkMode*/ ctx[3]);
			}
		},
		d(detaching) {
			if (detaching) detach(input);
			/*input_binding_3*/ ctx[35](null);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (103:28) 
function create_if_block_3(ctx) {
	let input;
	let mounted;
	let dispose;

	return {
		c() {
			input = element("input");
			attr(input, "type", "email");
			input.required = /*required*/ ctx[6];
			attr(input, "name", /*name*/ ctx[7]);
			attr(input, "autocomplete", /*autocomplete*/ ctx[8]);
			attr(input, "placeholder", /*placeholder*/ ctx[4]);
			attr(input, "style", "");
			attr(input, "class", "svelte-1luxt1k");
			toggle_class(input, "dark-mode", /*darkMode*/ ctx[3]);
		},
		m(target, anchor) {
			insert(target, input, anchor);
			set_input_value(input, /*value*/ ctx[15]);
			/*input_binding_2*/ ctx[31](input);

			if (!mounted) {
				dispose = [
					listen(input, "input", /*input_input_handler_2*/ ctx[30]),
					listen(input, "focus", /*focus_handler_2*/ ctx[32]),
					listen(input, "focusout", /*focusout_handler_2*/ ctx[33])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty[0] & /*required*/ 64) {
				input.required = /*required*/ ctx[6];
			}

			if (dirty[0] & /*name*/ 128) {
				attr(input, "name", /*name*/ ctx[7]);
			}

			if (dirty[0] & /*autocomplete*/ 256) {
				attr(input, "autocomplete", /*autocomplete*/ ctx[8]);
			}

			if (dirty[0] & /*placeholder*/ 16) {
				attr(input, "placeholder", /*placeholder*/ ctx[4]);
			}

			if (dirty[0] & /*value*/ 32768 && input.value !== /*value*/ ctx[15]) {
				set_input_value(input, /*value*/ ctx[15]);
			}

			if (dirty[0] & /*darkMode*/ 8) {
				toggle_class(input, "dark-mode", /*darkMode*/ ctx[3]);
			}
		},
		d(detaching) {
			if (detaching) detach(input);
			/*input_binding_2*/ ctx[31](null);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (75:29) 
function create_if_block_2(ctx) {
	let input;
	let mounted;
	let dispose;

	return {
		c() {
			input = element("input");
			attr(input, "type", "tel");
			input.required = /*required*/ ctx[6];
			attr(input, "name", /*name*/ ctx[7]);
			attr(input, "autocomplete", /*autocomplete*/ ctx[8]);
			attr(input, "placeholder", /*placeholder*/ ctx[4]);
			attr(input, "style", "");
			attr(input, "class", "svelte-1luxt1k");
			toggle_class(input, "dark-mode", /*darkMode*/ ctx[3]);
		},
		m(target, anchor) {
			insert(target, input, anchor);
			/*input_binding_1*/ ctx[25](input);
			set_input_value(input, /*value*/ ctx[15]);

			if (!mounted) {
				dispose = [
					listen(input, "input", /*input_input_handler_1*/ ctx[26]),
					listen(input, "focus", /*focus_handler_1*/ ctx[27]),
					listen(input, "focusout", /*focusout_handler_1*/ ctx[28]),
					listen(input, "keyup", /*keyup_handler_1*/ ctx[29])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty[0] & /*required*/ 64) {
				input.required = /*required*/ ctx[6];
			}

			if (dirty[0] & /*name*/ 128) {
				attr(input, "name", /*name*/ ctx[7]);
			}

			if (dirty[0] & /*autocomplete*/ 256) {
				attr(input, "autocomplete", /*autocomplete*/ ctx[8]);
			}

			if (dirty[0] & /*placeholder*/ 16) {
				attr(input, "placeholder", /*placeholder*/ ctx[4]);
			}

			if (dirty[0] & /*value*/ 32768) {
				set_input_value(input, /*value*/ ctx[15]);
			}

			if (dirty[0] & /*darkMode*/ 8) {
				toggle_class(input, "dark-mode", /*darkMode*/ ctx[3]);
			}
		},
		d(detaching) {
			if (detaching) detach(input);
			/*input_binding_1*/ ctx[25](null);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (54:1) {#if type === "text"}
function create_if_block_1(ctx) {
	let input;
	let input_id_value;
	let mounted;
	let dispose;

	return {
		c() {
			input = element("input");
			attr(input, "id", input_id_value = "t_" + /*name*/ ctx[7]);
			attr(input, "type", "text");
			input.required = /*required*/ ctx[6];
			attr(input, "name", /*name*/ ctx[7]);
			attr(input, "autocomplete", /*autocomplete*/ ctx[8]);
			attr(input, "placeholder", /*placeholder*/ ctx[4]);
			attr(input, "style", "");
			attr(input, "maxlength", /*maxlength*/ ctx[10]);
			attr(input, "class", "svelte-1luxt1k");
			toggle_class(input, "dark-mode", /*darkMode*/ ctx[3]);
		},
		m(target, anchor) {
			insert(target, input, anchor);
			/*input_binding*/ ctx[19](input);
			set_input_value(input, /*value*/ ctx[15]);

			if (!mounted) {
				dispose = [
					listen(input, "input", /*input_input_handler*/ ctx[20]),
					listen(input, "focus", /*focus_handler*/ ctx[21]),
					listen(input, "focusout", /*focusout_handler*/ ctx[22]),
					listen(input, "keyup", /*keyup_handler*/ ctx[23]),
					listen(input, "change", /*change_handler*/ ctx[24])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty[0] & /*name*/ 128 && input_id_value !== (input_id_value = "t_" + /*name*/ ctx[7])) {
				attr(input, "id", input_id_value);
			}

			if (dirty[0] & /*required*/ 64) {
				input.required = /*required*/ ctx[6];
			}

			if (dirty[0] & /*name*/ 128) {
				attr(input, "name", /*name*/ ctx[7]);
			}

			if (dirty[0] & /*autocomplete*/ 256) {
				attr(input, "autocomplete", /*autocomplete*/ ctx[8]);
			}

			if (dirty[0] & /*placeholder*/ 16) {
				attr(input, "placeholder", /*placeholder*/ ctx[4]);
			}

			if (dirty[0] & /*maxlength*/ 1024) {
				attr(input, "maxlength", /*maxlength*/ ctx[10]);
			}

			if (dirty[0] & /*value*/ 32768 && input.value !== /*value*/ ctx[15]) {
				set_input_value(input, /*value*/ ctx[15]);
			}

			if (dirty[0] & /*darkMode*/ 8) {
				toggle_class(input, "dark-mode", /*darkMode*/ ctx[3]);
			}
		},
		d(detaching) {
			if (detaching) detach(input);
			/*input_binding*/ ctx[19](null);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (122:4) {#if hasDelete}
function create_if_block(ctx) {
	let span;
	let mounted;
	let dispose;

	return {
		c() {
			span = element("span");
			span.textContent = "close";
			attr(span, "class", "material-symbols-outlined svelte-1luxt1k");
			set_style(span, "margin-right", "8px");
			set_style(span, "background-color", "#d3d3d3");
			set_style(span, "border-radius", "50%");
			set_style(span, "color", "#4d4d4d");
			set_style(span, "font-size", "14px");
			set_style(span, "cursor", "pointer");
		},
		m(target, anchor) {
			insert(target, span, anchor);

			if (!mounted) {
				dispose = listen(span, "click", /*click_handler*/ ctx[42]);
				mounted = true;
			}
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(span);
			mounted = false;
			dispose();
		}
	};
}

function create_fragment(ctx) {
	let link;
	let t0;
	let div;
	let t1;
	let t2;
	let div_class_value;
	let if_block0 = /*icon*/ ctx[1] && create_if_block_6(ctx);

	function select_block_type(ctx, dirty) {
		if (/*type*/ ctx[2] === "text") return create_if_block_1;
		if (/*type*/ ctx[2] === "tel") return create_if_block_2;
		if (/*type*/ ctx[2] === "email") return create_if_block_3;
		if (/*type*/ ctx[2] === "password") return create_if_block_4;
		if (/*type*/ ctx[2] === "textarea") return create_if_block_5;
	}

	let current_block_type = select_block_type(ctx, [-1, -1]);
	let if_block1 = current_block_type && current_block_type(ctx);
	let if_block2 = /*hasDelete*/ ctx[5] && create_if_block(ctx);

	return {
		c() {
			link = element("link");
			t0 = space();
			div = element("div");
			if (if_block0) if_block0.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			if (if_block2) if_block2.c();
			attr(link, "rel", "stylesheet");
			attr(link, "href", "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0");
			attr(link, "class", "svelte-1luxt1k");
			attr(div, "class", div_class_value = "input-container " + (/*hasFocus*/ ctx[13] ? 'focus' : '') + " " + (/*classes*/ ctx[9] ? /*classes*/ ctx[9] : '') + " svelte-1luxt1k");
			attr(div, "style", /*style*/ ctx[0]);
			toggle_class(div, "dark-mode", /*darkMode*/ ctx[3]);
		},
		m(target, anchor) {
			append(document.head, link);
			insert(target, t0, anchor);
			insert(target, div, anchor);
			if (if_block0) if_block0.m(div, null);
			append(div, t1);
			if (if_block1) if_block1.m(div, null);
			append(div, t2);
			if (if_block2) if_block2.m(div, null);
		},
		p(ctx, dirty) {
			if (/*icon*/ ctx[1]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_6(ctx);
					if_block0.c();
					if_block0.m(div, t1);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block1) {
				if_block1.p(ctx, dirty);
			} else {
				if (if_block1) if_block1.d(1);
				if_block1 = current_block_type && current_block_type(ctx);

				if (if_block1) {
					if_block1.c();
					if_block1.m(div, t2);
				}
			}

			if (/*hasDelete*/ ctx[5]) {
				if (if_block2) {
					if_block2.p(ctx, dirty);
				} else {
					if_block2 = create_if_block(ctx);
					if_block2.c();
					if_block2.m(div, null);
				}
			} else if (if_block2) {
				if_block2.d(1);
				if_block2 = null;
			}

			if (dirty[0] & /*hasFocus, classes*/ 8704 && div_class_value !== (div_class_value = "input-container " + (/*hasFocus*/ ctx[13] ? 'focus' : '') + " " + (/*classes*/ ctx[9] ? /*classes*/ ctx[9] : '') + " svelte-1luxt1k")) {
				attr(div, "class", div_class_value);
			}

			if (dirty[0] & /*style*/ 1) {
				attr(div, "style", /*style*/ ctx[0]);
			}

			if (dirty[0] & /*hasFocus, classes, darkMode*/ 8712) {
				toggle_class(div, "dark-mode", /*darkMode*/ ctx[3]);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			detach(link);
			if (detaching) detach(t0);
			if (detaching) detach(div);
			if (if_block0) if_block0.d();

			if (if_block1) {
				if_block1.d();
			}

			if (if_block2) if_block2.d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { style = "" } = $$props;
	let { icon = { name: "person" } } = $$props;
	let { type = "text" } = $$props;
	let { darkMode = true } = $$props;
	let { placeholder = "" } = $$props;
	let { hasDelete = false } = $$props;
	let { required = false } = $$props;
	let { name = null } = $$props;
	let { autocomplete = null } = $$props;
	let { classes = null } = $$props;
	let { maxlength = null } = $$props;
	let { numbersOnly = false } = $$props;
	let { rows = 3 } = $$props; // for textarea only
	let { defaultValue = null } = $$props;

	function getValue() {
		return value;
	}

	let hasFocus = false;
	let dispatch = createEventDispatcher();
	let inputField;
	let value;

	onMount(() => {
		if (inputField && name) {
			//console.log("SetTimeout...");
			setTimeout(
				() => {
					//console.log("field value " + name, inputField.value);
					$$invalidate(15, value = inputField.value);

					if (!value && defaultValue) {
						$$invalidate(15, value = defaultValue);
					}
				},
				300
			);
		}
	});

	function input_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			inputField = $$value;
			$$invalidate(14, inputField);
		});
	}

	function input_input_handler() {
		value = this.value;
		$$invalidate(15, value);
	}

	const focus_handler = () => {
		$$invalidate(13, hasFocus = true);
		dispatch("focus", { field: name });
	};

	const focusout_handler = () => {
		$$invalidate(13, hasFocus = false);
		dispatch("focusout", { field: name });
	};

	const keyup_handler = e => {
		if (numbersOnly) {
			let tmpValue = "";

			for (var i = 0; i < value.length; i++) {
				let ch = value.charAt(i);

				if (!isNaN(ch)) {
					tmpValue = tmpValue + ch;
				}
			}

			$$invalidate(15, value = tmpValue);
		}

		dispatch("keyup", e);
	};

	const change_handler = e => {
		dispatch("change", e);
	};

	function input_binding_1($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			inputField = $$value;
			$$invalidate(14, inputField);
		});
	}

	function input_input_handler_1() {
		value = this.value;
		$$invalidate(15, value);
	}

	const focus_handler_1 = () => {
		$$invalidate(13, hasFocus = true);
		dispatch("focus", { field: name });
	};

	const focusout_handler_1 = () => {
		$$invalidate(13, hasFocus = false);
		dispatch("focusout", { field: name });
	};

	const keyup_handler_1 = e => {
		if (value) {
			let tmpValue = "";

			for (var i = 0; i < value.length; i++) {
				let ch = value.charAt(i);

				if (isNaN(ch)) {
					if (ch === "+" && i === 0) {
						tmpValue = tmpValue + ch;
					}
				} else {
					tmpValue = tmpValue + ch;
				}
			}

			$$invalidate(15, value = tmpValue);
		}

		dispatch("keyup", e);
	};

	function input_input_handler_2() {
		value = this.value;
		$$invalidate(15, value);
	}

	function input_binding_2($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			inputField = $$value;
			$$invalidate(14, inputField);
		});
	}

	const focus_handler_2 = () => {
		$$invalidate(13, hasFocus = true);
		dispatch("focus", { field: name });
	};

	const focusout_handler_2 = () => {
		$$invalidate(13, hasFocus = false);
		dispatch("focusout", { field: name });
	};

	function input_input_handler_3() {
		value = this.value;
		$$invalidate(15, value);
	}

	function input_binding_3($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			inputField = $$value;
			$$invalidate(14, inputField);
		});
	}

	const focus_handler_3 = () => {
		$$invalidate(13, hasFocus = true);
		dispatch("focus", { field: name });
	};

	const focusout_handler_3 = () => {
		$$invalidate(13, hasFocus = false);
		dispatch("focusout", { field: name });
	};

	function textarea_input_handler() {
		value = this.value;
		$$invalidate(15, value);
	}

	function textarea_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			inputField = $$value;
			$$invalidate(14, inputField);
		});
	}

	const focus_handler_4 = () => {
		$$invalidate(13, hasFocus = true);
		dispatch("focus", { field: name });
	};

	const focusout_handler_4 = () => {
		$$invalidate(13, hasFocus = false);
		dispatch("focusout", { field: name });
	};

	const click_handler = () => $$invalidate(15, value = "");

	$$self.$$set = $$props => {
		if ('style' in $$props) $$invalidate(0, style = $$props.style);
		if ('icon' in $$props) $$invalidate(1, icon = $$props.icon);
		if ('type' in $$props) $$invalidate(2, type = $$props.type);
		if ('darkMode' in $$props) $$invalidate(3, darkMode = $$props.darkMode);
		if ('placeholder' in $$props) $$invalidate(4, placeholder = $$props.placeholder);
		if ('hasDelete' in $$props) $$invalidate(5, hasDelete = $$props.hasDelete);
		if ('required' in $$props) $$invalidate(6, required = $$props.required);
		if ('name' in $$props) $$invalidate(7, name = $$props.name);
		if ('autocomplete' in $$props) $$invalidate(8, autocomplete = $$props.autocomplete);
		if ('classes' in $$props) $$invalidate(9, classes = $$props.classes);
		if ('maxlength' in $$props) $$invalidate(10, maxlength = $$props.maxlength);
		if ('numbersOnly' in $$props) $$invalidate(11, numbersOnly = $$props.numbersOnly);
		if ('rows' in $$props) $$invalidate(12, rows = $$props.rows);
		if ('defaultValue' in $$props) $$invalidate(17, defaultValue = $$props.defaultValue);
	};

	return [
		style,
		icon,
		type,
		darkMode,
		placeholder,
		hasDelete,
		required,
		name,
		autocomplete,
		classes,
		maxlength,
		numbersOnly,
		rows,
		hasFocus,
		inputField,
		value,
		dispatch,
		defaultValue,
		getValue,
		input_binding,
		input_input_handler,
		focus_handler,
		focusout_handler,
		keyup_handler,
		change_handler,
		input_binding_1,
		input_input_handler_1,
		focus_handler_1,
		focusout_handler_1,
		keyup_handler_1,
		input_input_handler_2,
		input_binding_2,
		focus_handler_2,
		focusout_handler_2,
		input_input_handler_3,
		input_binding_3,
		focus_handler_3,
		focusout_handler_3,
		textarea_input_handler,
		textarea_binding,
		focus_handler_4,
		focusout_handler_4,
		click_handler
	];
}

class InputField extends SvelteComponent {
	constructor(options) {
		super();

		init(
			this,
			options,
			instance,
			create_fragment,
			safe_not_equal,
			{
				style: 0,
				icon: 1,
				type: 2,
				darkMode: 3,
				placeholder: 4,
				hasDelete: 5,
				required: 6,
				name: 7,
				autocomplete: 8,
				classes: 9,
				maxlength: 10,
				numbersOnly: 11,
				rows: 12,
				defaultValue: 17,
				getValue: 18
			},
			null,
			[-1, -1]
		);
	}

	get getValue() {
		return this.$$.ctx[18];
	}
}

export default InputField;